<template>
  <div class="shjjzb">
    <div class="operate">
      <div class="title">
        <span class="yuan"></span>2000-2030年{{ this.city }}社会经济指标
      </div>
      <div class="echarts1" ref="echarts1"></div>
      <div class="echarts2" ref="echarts2"></div>
    </div>
    <div class="mapBox">
      <div class="title"><span class="yuan"></span>长三角社会经济指标</div>
      <div class="map" ref="map"></div>
      <el-date-picker
        class="mapYear"
        v-model="defaultYear"
        size="small"
        type="year"
        placeholder=""
        @change="handleChangeMapYear"
        :clearable="false"
      >
      </el-date-picker>
    </div>
    <div class="echartsBox">
      <div class="title">
        <span class="yuan"></span>{{ this.year
        }}{{ this.city }}社会经济指标各类占比
      </div>
      <div class="glzb">
        <div class="glzb_line">
          <div class="echarts3 glzb_line_item" ref="echarts3"></div>
          <div class="echarts4 glzb_line_item" ref="echarts4"></div>
        </div>
        <div class="glzb_line">
          <div class="echarts5 glzb_line_item" ref="echarts5"></div>
          <div class="echarts6 glzb_line_item" ref="echarts6"></div>
        </div>
      </div>
    
    </div>
  </div>
</template>
<script>
import apiService from "@/request/api";
import anhui from "@/assets/anhui.json";
import zhejiang from "@/assets/zhejiang.json";
import shanghaishi from "@/assets/shanghaishi.json";
import jiangshu from "@/assets/jiangshu.json";

import Options from "./options.js";
import * as Echarts from "echarts";
import moment from "moment";
export default {
  data() {
    return {
      city: "上海",
      Options: Options,
      zhibiao: ["经济发展", "GDP(亿元)"],
      startYear: "",
      endYear: "",
      year: "",
      mincolor: 0,
      maxcolor: 100,
      defaultYear: "",
      dataList: [],
      dataList1: [],
      dataListMap1: [],
      xDate: [],
      yData: [],
      map: null,
      map1: null,
      charts1: "",
      charts2: "",
      charts3: "",
      charts4: "",
      charts5: "",
      charts6: "",
      yearList: [],
      jjlist: [0, 0, 0, 0, 0, 0],
      nylist: [0, 0, 0, 0, 0, 0],
      gylist: [0, 0, 0, 0],
      jtlist: [0, 0, 0, 0],
      jjsum: [],
      nysum: [],
      gysum: [],
      jtsum: [],
    };
  },
  methods: {
    handleChangeCity(value) {
      console.log(value, "cityvalue", this.city);

      this.getlist1();
    },
    handleChangeZb(value) {
      console.log(value);
      this.init();
    },
    handleChangeMapYear(value) {
      console.log(this.defaultYear);
      this.charts1.clear();
      this.charts2.clear();
      this.charts3.clear();
      this.charts4.clear();
      this.charts5.clear();
      this.charts6.clear();
      this.getlist2();
      this.getlist1();
      // this.initEcharts();
    },
    handleChangeEndYear(value) {
      const sYear = new Date(this.startYear).getFullYear();
      const eYear = new Date(this.endYear).getFullYear();
      if (sYear < eYear || sYear == eYear) {
        this.getlist1();
      } else {
        this.$message.error("开始年份需早于或等于截至年份");
      }
    },
    handleChangeStartYear(value) {
      this.initEcharts();
    },
    async initEcharts() {
      this.dataList = [];

      var csj = {
        type: "FeatureCollection",
        features: shanghaishi.features.concat(
          zhejiang.features,
          anhui.features,
          jiangshu.features
        ),
      };

      const _this = this;
      _this.map = Echarts.init(this.$refs["map"]);
      const option = {
        series: [
          {
            name: "城市",
            type: "map",
            geoIndex: 0,
            data: _this.dataList,
          },
        ],
        geo: {
          //地图配置
          map: "csj",
          zoom: 1.2,
          // roam: true,
          itemStyle: {
            //地图区域样式
            normal: {
              borderColor: "#5089ec",
              borderWidth: 1,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 102, 154, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 102, 154, .4)", // 100% 处的颜色
                  },
                ],
              },
            },
            emphasis: {
              //高亮样式
              areaColor: "#2386AD",
            },
          },
          //   regions: [{
          //     name: '上海市', // 省份名，确保是 ECharts 中有的省份名
          //     itemStyle: {
          //         normal: {
          //             areaColor: 'red',
          //             borderColor: 'yellow' // 广东省份的边界颜色
          //         },
          //         emphasis: {
          //             areaColor: 'red'
          //         }
          //     }
          // }],

          label: {
            //文本标签样式
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
                fontSize:16
              },
            },
            emphasis: {
              //高亮样式
              textStyle: {
                color: "yellow",
              },
            },
          },
          // 鼠标悬浮提示框
        },
      };
      Echarts.registerMap("csj", csj);
      _this.map.setOption(option);
      _this.map.on("click", function (params) {
        console.log(params.name);
        _this.city = params.name.replace("市", "");
        console.log(111, _this.city);
        _this.handleChangeMapYear();
      });
      // charts.dispatchAction({
      //   type: 'highlight',
      //   seriesIndex: 0,
      //   dataIndex: charts.getOption().series[0].data.findIndex(item => item.name === "上海市")
      // });
    },

    async initEcharts1() {
      const _this = this;

      this.charts1 = Echarts.init(this.$refs["echarts1"]);
      // 默认数据
      let seriesData = {
        categories: this.yearList,
        series: [
          {
            name: "经济",
            data: this.jjsum,
          },
          {
            name: "工业",
            data: this.gysum,
          },
        ],
      };
      const colorList = ["#1165b2", "#b53333", "#F6ED0D", "#FD2BFF", "#9E87FF"];
      let series = [];
      seriesData.series.forEach((item, index) => {
        console.log(seriesData.series.length - 1, index, "0909");
        series.push({
          name: item.name,
          type: "line",
          data: item.data,
          symbolSize: 7,
          symbol: "circle",
          smooth: true,
          yAxisIndex: seriesData.series.length - 1 == index ? 1 : 0,
          showSymbol: true,
          lineStyle: {
            width: 2,
            color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: colorList[index],
              },
              {
                offset: 1,
                color: colorList[index],
              },
            ]),
          },
          itemStyle: {
            color: colorList[index], // 设置圆形的填充色
            borderColor: "#ffffff", // 设置边框颜色
            borderWidth: 1, // 设置边框宽度
          },
        });
      });
      let option = {
        backgroundColor: "#00000000",
        //你的代码
        legend: {
          icon: "circle",
          top: "5%",
          right: "5%",
          itemWidth: 10,
          itemGap: 20,
          textStyle: {
            color: "#fff",
            fontSize:16
          },
        },
        grid: {
          top: "25%",
          bottom: "15%",
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var str = `${params[0].name}<br/>`;
            params.forEach((par) => {
              str += `${par.marker} ${par.seriesName}：${par.value} ${
                par.seriesName == "经济" ? "亿元" : "亿元"
              }<br/>`;
            });
            return str;
          },
        },
        //dataZoom 组件 用于区域缩放
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
            realtime: true,
            //移动端展示方式
            handleSize: "100%",
            start: 0,
            end: 30,
            height: 10,
            bottom: 8,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: seriesData.categories ? seriesData.categories : [],
            axisLine: {
              lineStyle: {
                color: "#3DECFF",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
              },
              // 默认x轴字体大小
              fontSize: 12,
              // margin:文字到x轴的距离
              margin: 15,
            },
            axisPointer: {
              label: {
                // padding: [11, 5, 7],
                padding: [0, 0, 10, 0],
                // 这里的margin和axisLabel的margin要一致!
                margin: 15,
                // 移入时的字体大小
                fontSize: 12,
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      // offset: 0.9,
                      offset: 0.86,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.86,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：亿元",
            nameTextStyle: {
              color: "#1165b2",
              fontSize:16
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#1165b2",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#1165b2",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255,0.5)",
              },
            },
          },
          {
            type: "value",
            name: "单位：亿元",
            nameTextStyle: {
              color: "#b53333",
              fontSize:16
            },
            position: "right",
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#b53333",
              },
              formatter: "{value}",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#b53333",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [...series],
      };
      this.charts1.setOption(option);
    },
    async initEcharts2() {
      const _this = this;

      this.charts2 = Echarts.init(this.$refs["echarts2"]);
      // 默认数据
      let seriesData = {
        categories: this.yearList,
        series: [
          {
            name: "农业",
            data: this.nysum,
          },
          {
            name: "交通业",
            data: this.jtsum,
          },
        ],
      };
      const colorList = ["#af620f", "#20927f", "#F6ED0D", "#FD2BFF", "#9E87FF"];
      let series = [];
      seriesData.series.forEach((item, index) => {
        console.log(seriesData.series.length - 1, index, "0909");
        series.push({
          name: item.name,
          type: "line",
          data: item.data,
          symbolSize: 7,
          symbol: "circle",
          smooth: true,
          yAxisIndex: seriesData.series.length - 1 == index ? 1 : 0,
          showSymbol: true,
          lineStyle: {
            width: 2,
            color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: colorList[index],
              },
              {
                offset: 1,
                color: colorList[index],
              },
            ]),
          },
          itemStyle: {
            color: colorList[index], // 设置圆形的填充色
            borderColor: "#ffffff", // 设置边框颜色
            borderWidth: 1, // 设置边框宽度
          },
        });
      });
      let option = {
        backgroundColor: "#00000000",
        //你的代码
        legend: {
          icon: "circle",
          top: "5%",
          right: "5%",
          itemWidth: 10,
          itemGap: 20,
          textStyle: {
            color: "#fff",
            fontSize:16
          },
        },
        grid: {
          top: "25%",
          bottom: "15%",
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var str = `${params[0].name}<br/>`;
            params.forEach((par) => {
              str += `${par.marker} ${par.seriesName}：${par.value} ${
                par.seriesName == "农业" ? "吨" : "万吨"
              }<br/>`;
            });
            return str;
          },
        },
        //dataZoom 组件 用于区域缩放
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7],
            realtime: true,
            //移动端展示方式
            handleSize: "100%",
            start: 0,
            end: 30,
            height: 10,
            bottom: 20,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: seriesData.categories ? seriesData.categories : [],
            axisLine: {
              lineStyle: {
                color: "#3DECFF",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
              },
              // 默认x轴字体大小
              fontSize: 12,
              // margin:文字到x轴的距离
              margin: 15,
            },
            axisPointer: {
              label: {
                // padding: [11, 5, 7],
                padding: [0, 0, 10, 0],
                // 这里的margin和axisLabel的margin要一致!
                margin: 15,
                // 移入时的字体大小
                fontSize: 12,
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      // offset: 0.9,
                      offset: 0.86,
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.86,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：吨",
            nameTextStyle: {
              color: "#af620f",
              fontSize:16
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#af620f",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#af620f",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(255,255,255,0.5)",
              },
            },
          },
          {
            type: "value",
            name: "单位：万吨",
            nameTextStyle: {
              color: "#20927f",
              fontSize:16
            },
            position: "right",
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#20927f",
              },
              formatter: "{value}",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#20927f",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [...series],
      };
      this.charts2.setOption(option);
    },
    initEcharts3() {
      const _this = this;
      this.charts3 = Echarts.init(this.$refs["echarts3"]);
      let information = {
        dataArray: [
          {
            name: "第一产业总产值(亿元)",
            value: this.jjlist[0],
          },
          {
            name: "第二产业总产值(亿元)",
            value: this.jjlist[1],
          },
          {
            name: "第三产业总产值(亿元)",
            value: this.jjlist[2],
          },
          {
            name: "种植业产值（亿元）",
            value: this.jjlist[3],
          },
          {
            name: "林业产值（亿元）",
            value: this.jjlist[4],
          },
          {
            name: "牧业产值（亿元）",
            value: this.jjlist[5],
          },
        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.8)",
          borderColor: "rgba(9,40,84,0.8)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>" +
              "(" +
              params.percent +
              "%)"
            );
          },
          // formatter: "{b} : {c} ({d}%)",
        },
        title: {
          text: "经济占比图",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 8,
          itemHeight: 8,
          width: "240",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 10,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 8,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts3.setOption(option);
    },
    initEcharts4() {
      const _this = this;
      this.charts4 = Echarts.init(this.$refs["echarts4"]);
      let information = {
        dataArray: [
          {
            name: "农用化肥施用折纯量(吨)",
            value: this.nylist[0],
          },
          {
            name: "农用氮肥施用折纯量(吨)",
            value: this.nylist[1],
          },
          {
            name: "农用磷肥施用折纯量(吨)",
            value: this.nylist[2],
          },
          {
            name: "农用钾肥施用折纯量(吨)",
            value: this.nylist[3],
          },
          {
            name: "农用复合肥施用折纯量(吨)",
            value: this.nylist[4],
          },
          {
            name: "农药使用量(吨)",
            value: this.nylist[5],
          },
        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.8)",
          borderColor: "rgba(9,40,84,0.8)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>" +
              "(" +
              params.percent +
              "%)"
            );
          },
          // formatter: "{b} : {c} ({d}%)",
        },
        title: {
          text: "农业占比图",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 8,
          itemHeight: 8,
          width: "250",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 10,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 8,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts4.setOption(option);
    },
    initEcharts5() {
      const _this = this;
      this.charts5 = Echarts.init(this.$refs["echarts5"]);
      let information = {
        dataArray: [
          {
            name: "建筑业总产值（亿元）",
            value: this.gylist[0],
          },
          {
            name: "规模以上工业总产值(亿元)",
            value: this.gylist[1],
          },
          {
            name: "轻工业（亿元）",
            value: this.gylist[2],
          },
          {
            name: "重工业（亿元）",
            value: this.gylist[3],
          },
        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.8)",
          borderColor: "rgba(9,40,84,0.8)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>" +
              "(" +
              params.percent +
              "%)"
            );
          },
          // formatter: "{b} : {c} ({d}%)",
        },
        title: {
          text: "工业占比图",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 8,
          itemHeight: 8,
          width: "240",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 10,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 8,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts5.setOption(option);
    },
    initEcharts6() {
      const _this = this;
      this.charts6 = Echarts.init(this.$refs["echarts6"]);
      let information = {
        dataArray: [
          {
            name: "货运量（万吨）",
            value: this.jtlist[0],
          },
          {
            name: "铁路货运量（万吨）",
            value: this.jtlist[1],
          },
          {
            name: "公路货运量（万吨）",
            value: this.jtlist[2],
          },
          {
            name: "水运货运量（万吨）",
            value: this.jtlist[3],
          },
        ],
        colorArray: [
          "#1165b2",
          "#b53333",
          "#af620f",
          "#90980c",
          "#20927f",
          "#2726ac",
          "#8c26ac",
          "#6721c4",
        ],
      };
      let option = {
        // backgroundColor: "#021032",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9,40,84,0.8)",
          borderColor: "rgba(9,40,84,0.8)",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
          formatter: function (params) {
            return (
              '<span style="margin-right: 5px; border-radius: 50%; display: inline-block; width:14px; height: 14px; vertical-align: middle; background-color: ' +
              params.color +
              ';"></span>' +
              params.name +
              "&nbsp;&nbsp;<span style='font-weight:bold'>" +
              Number(params.value).toExponential(3) +
              "</span>" +
              "(" +
              params.percent +
              "%)"
            );
          },
          // formatter: "{b} : {c} ({d}%)",
        },
        title: {
          text: "交通占比图",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 16,
            color: "#fff",  
          },
        },
        legend: {
          show: true,
          right: "center",
          bottom: "10%",
          icon: "rect",
          itemWidth: 8,
          itemHeight: 8,
          width: "240",
          textStyle: {
            //图例文字的样式
            color: "#b4e4ff",
            fontSize: 10,
            // 给出高度和rich对象，实现图标与文字居中对齐
            height: 8,
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            color: information.colorArray,
            type: "pie",
            radius: ["0", "50%"],
            center: ["50%", "40%"],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: information.dataArray,
          },
          {
            // 外环
            type: "pie",
            silent: true, //取消高亮
            radius: ["0", "53%"],
            center: ["50%", "40%"],
            data: [100],
            itemStyle: {
              color: "rgba(18, 63, 115, 0.3)",
            },
            label: {
              show: false,
            },
            z: 0,
          },
        ],
      };
      this.charts6.setOption(option);
    },
    async init() {
      this.initEcharts();
      this.getlist1();
      this.getlist2();
    },
    async getlist1() {
      const params = {
        all: 1,
        page_size: 10000,
        page: 1,
        year: "",
        min_year: "",
        max_year: "",
        city: this.city,
        province: "",
        factors: "",
        type: "",
      };
      const res = await apiService.socialeconomy(params);
      let list = res.data.results;
      console.log(res, "经济数据");
      this.yearList = [];
      this.jjsum = [];
      this.nysum = [];
      this.gysum = [];
      this.jtsum = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].type == "第一产业总产值(亿元)") {
          this.yearList.push(list[i].year);
        }
      }
      for (var i = 0; i < this.yearList.length; i++) {
        this.jjsum[i] = 0;
        this.nysum[i] = 0;
        this.gysum[i] = 0;
        this.jtsum[i] = 0;
        for (var j = 0; j < list.length; j++) {
          if (list[j].year == this.yearList[i]) {
            if (list[j].factors == "经济") {
              this.jjsum[i] += Number(list[j].value) * 10000;
            }
            if (list[j].factors == "农业") {
              this.nysum[i] += Number(list[j].value) * 10000;
            }
            if (list[j].factors == "工业") {
              this.gysum[i] += Number(list[j].value) * 10000;
            }
            if (list[j].factors == "交通") {
              this.jtsum[i] += Number(list[j].value) * 10000;
            }
          }
        }
        this.jjsum[i] = this.jjsum[i] / 10000;
        this.nysum[i] = this.nysum[i] / 10000;
        this.gysum[i] = this.gysum[i] / 10000;
        this.jtsum[i] = this.jtsum[i] / 10000;
      }

      this.initEcharts1();
      this.initEcharts2();
    },
    async getlist2() {
      const params = {
        all: 1,
        page_size: 10000,
        page: 1,
        year: new Date(this.defaultYear).getFullYear(),
        min_year: "",
        max_year: "",
        city: this.city,
        province: "",
        factors: "",
        type: "",
      };
      const res = await apiService.socialeconomy(params);
      let list = res.data.results;
      console.log(list, "本年本城市数据");

      for (var i = 0; i < list.length; i++) {
        if (list[i].factors == "经济") {
          if (list[i].type == "第一产业总产值(亿元)") {
            this.jjlist[0] = list[i].value;
          } else if (list[i].type == "第二产业总产值(亿元)") {
            this.jjlist[1] = list[i].value;
          } else if (list[i].type == "第三产业总产值(亿元)") {
            this.jjlist[2] = list[i].value;
          } else if (list[i].type == "种植业产值（亿元）") {
            this.jjlist[3] = list[i].value;
          } else if (list[i].type == "林业产值（亿元）") {
            this.jjlist[4] = list[i].value;
          } else if (list[i].type == "牧业产值（亿元）") {
            this.jjlist[5] = list[i].value;
          }
        }
        if (list[i].factors == "农业") {
          if (list[i].type == "农用化肥施用折纯量(吨)") {
            this.nylist[0] = list[i].value;
          } else if (list[i].type == "农用氮肥施用折纯量(吨)") {
            this.nylist[1] = list[i].value;
          } else if (list[i].type == "农用磷肥施用折纯量(吨)") {
            this.nylist[2] = list[i].value;
          } else if (list[i].type == "农用钾肥施用折纯量(吨)") {
            this.nylist[3] = list[i].value;
          } else if (list[i].type == "农用复合肥施用折纯量(吨)") {
            this.nylist[4] = list[i].value;
          } else if (list[i].type == "农药使用量(吨)") {
            this.nylist[5] = list[i].value;
          }
        }
        if (list[i].factors == "工业") {
          if (list[i].type == "建筑业总产值（亿元）") {
            this.gylist[0] = list[i].value;
          } else if (list[i].type == "规模以上工业总产值(亿元)") {
            this.gylist[1] = list[i].value;
          } else if (list[i].type == "轻工业（亿元）") {
            this.gylist[2] = list[i].value;
          } else if (list[i].type == "重工业（亿元）") {
            this.gylist[3] = list[i].value;
          }
        }
        if (list[i].factors == "交通") {
          if (list[i].type == "货运量(万吨)") {
            this.jtlist[0] = list[i].value;
          } else if (list[i].type == "铁路货运量(万吨)") {
            this.jtlist[1] = list[i].value;
          } else if (list[i].type == "公路货运量(万吨)") {
            this.jtlist[2] = list[i].value;
          } else if (list[i].type == "水运货运量(万吨)") {
            this.jtlist[3] = list[i].value;
          }
        }
      }
      this.initEcharts3();
      this.initEcharts4();
      this.initEcharts5();
      this.initEcharts6();
    },
  },
  watch: {
    defaultYear(val, value) {
      this.year = new Date(val).getFullYear();
    },
  },
  mounted() {
    this.defaultYear = new Date();
    this.init();
  },
};
</script>
<style  lang="scss">
.shjjzb {
  height: 100%;
  display: flex;
  justify-content: space-between;
  input {
    background-color: rgba(0, 0, 0, 0) !important;
    border-color: #01aed2;
    color: #fff;

    // height: 20px;
    font-size: 12px;
    border-radius: 8px;
  }
  .operate {
    width: 250px;
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .operateBox {
      display: flex;
      justify-content: space-between;
      // flex-direction: column;
      // align-items: end;
      .operateItem {
        width: 200px;
        margin-bottom: 30px;
      }
      .el-select {
        width: 200px;
      }
    }
    .yearBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        width: 200px !important;
      }
    }
    .grid {
      display: flex;
      width: 98%;
      border: 1px solid #01aed2;
      margin: 40px 0 40px 10px;

      .gridHead {
        width: 80px;
        border-right: 1px solid #01aed2;
        div {
          text-align: center;
          line-height: 38px;
        }
        div:nth-child(1) {
          border-bottom: 1px solid #01aed2;
        }
      }
      .gridData {
        flex: 1;
        display: flex;
        overflow: hidden;
        .gridItem {
          min-width: 100px;
          border-right: 1px solid #01aed2;
          div {
            text-align: center;
            line-height: 38px;
          }
          div:nth-child(1) {
            border-bottom: 1px solid #01aed2;
          }
        }
      }
      .gridData:hover {
        overflow: auto;
      }
      .gridData::-webkit-scrollbar {
        height: 5px;
        height: 5px;
      }
      .gridData::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #01aed2;
        cursor: pointer;
      }

      .gridData::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
    .stitle {
      height: 40px;
      background-image: url(@/imgs/2-小标题.png);
      background-size: cover;
      line-height: 38px;
      padding-left: 20px;

      width: 200px;
    }
    .echarts1 {
      width: 100%;
      flex: 1;
    }
    .echarts2 {
      width: 100%;
      flex: 1;
    }
  }
  .mapBox {
    
    flex: 1;
    // display: flex;
    // align-items: center;
    position: relative;
    .mapYear {
      position: absolute;
      right: 10px;
      top: 38px;
      width: 100px;
    }
    .map {
      width: 100%;
      height: 90%;
      background-image: url(@/imgs/quanxi.png);
      background-position: bottom;
      background-repeat: no-repeat;
      background-size: 100% 30%;
    }
  }
  .echartsBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    .glzb {
      flex: 1;
      display: flex;
      flex-direction: column;
      .glzb_line {
        display: flex;
        flex: 1;
        .glzb_line_item {
          width: 80%;
          height: 100%;
          // border: 1px solid gray;
        }
      }
    }
    .zaTable {
      height: 150px;
    }
  }
  .title {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 20px;
    padding: 4px;
    color: rgb(5, 225, 250);
    .yuan {
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: rgb(5, 225, 250);
      margin-right: 4px;
    }
  }
}
</style>